<h2 class="count-calls">{{ 'call' | locale }} {{ index + 1 }} {{ 'of' | locale }} {{ totalCalls }}</h2>

<div class="call-info">
  <h2 class="call-date">{{ 'call' | locale }} {{ 'of' | locale }} {{ call.createdAt | momentDate : "LL HH:mm" }}hs</h2>

  @if (isFamilyMemberCall) {
    <span class="family-member-call">
      {{ ('family_member_call' | locale) + ': ' + (call.caller?.name) }}
    </span>
  }
</div>

<h1>{{ 'professional_name' | locale }}</h1>
<p>{{ call.doctor.name || '-' }} ({{ call.doctor.enrollmentType }}{{ call.doctor.enrollment ? '. ' + call.doctor.enrollment : ''}})</p>
<mat-divider></mat-divider>

<h1>{{ 'specialty' | locale }}</h1>
<p> {{ call.specialty?.name || '-'  }}</p>
<mat-divider></mat-divider>

<h1>{{ 'call_provider' | locale }}</h1>
<p> {{ call.provider?.name || '-'  }}</p>
<mat-divider></mat-divider>

<h1>{{ 'diagnosis_motive_label' | locale }}</h1>
<p> {{ call.diagnosis?.motive || call.motive || '-' }}</p>
<mat-divider></mat-divider>

<h1>{{ 'medical_history' | locale }}</h1>
@if (call.diagnosis?.patientRecords) {
  <p>{{ call.diagnosis.patientRecords }}</p>
} @else {
  @if (medicalHistory) {
    <ul class="aligned-list">
      @for (record of medicalHistory?.split(','); track record) {
        <li>{{ record }}</li>
      }
    </ul>
  }
}
@if (!call.diagnosis?.patientRecords && !medicalHistory) {
  <p>-</p>
}
<mat-divider></mat-divider>

<h1>{{ 'progress_notes' | locale }}</h1>
<mat-form-field class="textarea">
  <textarea
    matInput
    rows="4"
    [value]="call.diagnosis?.text || '-'"
    placeholder="-"
    readonly
    >
  </textarea>
</mat-form-field>

<h1>{{ 'diagnosis' | locale }}</h1>
<p>
  {{ call.diagnosis?.diagnosis ? call.diagnosis.diagnosis : '-'
  }}{{ call.diagnosis?.description ? ' - ' + call.diagnosis.description : '' }}
</p>
<mat-divider></mat-divider>

<h1>{{ 'treatment' | locale }}</h1>
<mat-form-field class="textarea">
  <textarea
    matInput
    rows="4"
    [value]="call.diagnosis?.treatment || '-'"
    placeholder="-"
    readonly
    >
  </textarea>
</mat-form-field>

@if (call.prescriptions && call.prescriptions.length > 0) {
  <h1>{{ 'medicines_prescription' | locale }}</h1>
  @for (prescription of call.prescriptions; track prescription) {
    @for (medicine of prescription.medicines; track medicine) {
      <ul class="aligned-list">
        <li>{{ medicine.active }} {{medicine.pot}}. ({{ medicine.quantity }}) {{ medicine.instructions }}</li>
        <span class="badge {{ prescription.status | lowercase }}">{{ 'hc_medical_prescriptions_' + prescription.status | lowercase | locale }}</span>
        @if (medicine.pot?.trim() === 'No Clasificada') {
          <ul class="aligned-list">
            @for (component of medicine.drugs?.split('+'); track component) {
              <li>{{ component }}</li>
            }
          </ul>
        }
      </ul>
    }
  }
  <mat-divider></mat-divider>
}

@if (call.medicalOrders && call.medicalOrders.length > 0) {
  <h1>{{ 'hc_medical_orders_label' | locale }}</h1>
  @for (order of call.medicalOrders; track order) {
    <ul class="aligned-list">
      @if (order.practices?.length > 0) {
        <li>
          @for (practice of order.practices; track practice; let last = $last) {
            {{ practice.name }}<span>{{ !last ? ', ' : '.' }}</span>
          }
        </li>
      }
      @if (order.description?.trim().length > 0) {
        <li>{{ order.description }}</li>
      }
      @if (order.instructions?.trim().length > 0) {
        <li>{{ order.instructions }}</li>
      }
    </ul>
  }
  @if (call.restIndication) {
    <mat-divider></mat-divider>
    <mat-checkbox
      class="read-only"
      [checked]="true"
      [disabled]="true">
      {{ 'rest_indication' | locale }}
    </mat-checkbox>
  }
}
